(function () {
  'use strict';

  /*
   * This picker is an editorial gift guide, not a scoring system. It keeps
   * its answers in memory for the open page only. No photo, name, email or
   * other personal detail is requested, sent or stored.
   */
  var QUESTIONS = [
    {
      id: 'world',
      label: 'Who are you shopping for?',
      options: [
        { id: 'memorial', title: 'Someone remembering a pet', desc: 'Memorials and keepsakes' },
        { id: 'rat', title: 'A rat or small-pet keeper', desc: 'Cage care and enrichment' },
        { id: 'home', title: 'A home or garden lover', desc: 'Sculptural decor and planters' },
        { id: 'mixed', title: 'I am still exploring', desc: 'One useful gift from each world' }
      ]
    },
    {
      id: 'need',
      label: 'What should the gift do?',
      options: [
        { id: 'personal', title: 'Carry a personal clue', desc: 'A photo, name or short wording' },
        { id: 'useful', title: 'Be useful every day', desc: 'A practical pet or home piece' },
        { id: 'sculptural', title: 'Bring in a sculptural form', desc: 'A shape with presence' },
        { id: 'reflective', title: 'Catch the light', desc: 'Reflective decor for a room' }
      ]
    },
    {
      id: 'details',
      label: 'What do you have ready?',
      options: [
        { id: 'photo', title: 'A clear photo', desc: 'Check photo requirements on the product page' },
        { id: 'name', title: 'A name or short wording', desc: 'For products that accept personalisation' },
        { id: 'both', title: 'A photo and a name', desc: 'A useful start for photo-led keepsakes' },
        { id: 'none', title: 'Nothing personal yet', desc: 'Browse standard designs first' }
      ]
    }
  ];

  var ITEMS = {
    customBust: {
      title: 'Custom Pet Bust from Photo',
      href: '/products/custom-pet-bust',
      image: { src: 'https://cdn.shopify.com/s/files/1/0834/5446/0252/files/01-warm-marble-grey-pet-busts-group.png?v=1782760728', alt: 'Warm Marble Grey custom pet bust examples with engraved bases' },
      detail: 'Marble-effect polymer, indoor display. Photo-led, with optional base wording.',
    },
    customWall: {
      title: 'Custom Pet Memorial Wall Art',
      href: '/products/custom-pet-memorial-wall-art',
      image: { src: 'https://cdn.shopify.com/s/files/1/0834/5446/0252/files/hero-experiment-20260905-4495488562.png?v=1788625439', alt: 'Custom Pet Memorial Wall Art from Photo product hero view' },
      detail: 'Soft marble-effect finish, indoor display. Photo and pet name.',
    },
    customPlanter: {
      title: 'Custom Pet Portrait Planter',
      href: '/products/custom-pet-cast-stone-plant-pot',
      image: { src: 'https://cdn.shopify.com/s/files/1/0834/5446/0252/files/proposal-00-dog-led-mobile-hero.png?v=1787760114', alt: 'Custom dog portrait planter beside the pet photograph that inspired it' },
      detail: 'Solid cast stone. Photo-led planter with optional wording.',
    },
    acornMarker: {
      title: 'Personalised Acorn Grave Marker',
      href: '/products/personalised-acorn-grave-marker',
      image: { src: 'https://cdn.shopify.com/s/files/1/0834/5446/0252/files/2026-05-27-171759-1509229164652265662-1509229165566754936-content.png?v=1779902796', alt: 'Personalised acorn grave marker, product photo 1' },
      detail: 'Hand-finished cast stone. Indoor, garden or sheltered outdoor spot. Pet name.',
    },
    pawMarker: {
      title: 'Personalised Paw Grave Marker',
      href: '/products/personalised-paw-grave-marker',
      image: { src: 'https://cdn.shopify.com/s/files/1/0834/5446/0252/files/2026-05-27-212941-1509292507308232935-1509292508302278676-content.png?v=1779915031', alt: 'Personalised paw grave marker, product photo 1' },
      detail: 'Hand-finished cast stone. Indoor, garden or sheltered outdoor spot. Pet name.',
    },
    sleepingCat: {
      title: 'Sleeping Cat Statue',
      href: '/products/tranquil-cat-garden-statue-pet-memorial',
      image: { src: 'https://cdn.shopify.com/s/files/1/0834/5446/0252/files/sleeping-cat-garden-statue-02.png?v=1780337046', alt: 'Sleeping Cat Garden Statue front view showing hand-finished cast stone detail' },
      detail: 'Solid cast stone. Indoor or outdoor display. Standard design.',
    },
    acornUrn: {
      title: 'Memorial Acorn House Keepsake Urn',
      href: '/products/memorial-acorn-house-keepsake-urn',
      image: { src: 'https://cdn.shopify.com/s/files/1/0834/5446/0252/files/memorial-acorn-house-keepsake-urn-1.png?v=1781618086', alt: 'Cast stone acorn house keepsake urn with personalised initial on the door frame' },
      detail: 'Cast stone. One initial, with indoor or outdoor placement.',
    },
    memorialCollection: {
      title: 'Browse pet memorial stones',
      href: '/collections/pet-memorial-stones-grave-markers',
      detail: 'Compare current name-led and standard cast-stone memorial pieces.',
    },
    photoCollection: {
      title: 'Browse photo to sculpture',
      href: '/collections/personalised-busts',
      detail: 'Compare current photo-led sculpture options and their requirements.',
    },
    urnCollection: {
      title: 'Browse keepsake urns',
      href: '/collections/pet-urns-keepsake-urns',
      detail: 'Compare current urn and keepsake options before choosing a design.',
    },
    ratStarter: {
      title: 'Rat Cage Accessories Starter Kit',
      href: '/products/new-rat-parent-starter-kit',
      image: { src: 'https://cdn.shopify.com/s/files/1/0834/5446/0252/files/12_d6fd9ac4-607d-453a-95b9-78053d0e39f3.png?v=1779112442', alt: 'New rat parent starter kit main product photo' },
      detail: 'Ready-made cage bundle with hideaway, forage cups and food bowl. Check fit.',
    },
    ratCloud: {
      title: 'Cloud Rat Shelves and Hideaway Set',
      href: '/products/cloud-rat-shelves-hideaway-set',
      image: { src: 'https://cdn.shopify.com/s/files/1/0834/5446/0252/files/12_41f6c2e0-98c6-4f8f-866a-a585f9b5e3f3.png?v=1743373899', alt: 'Cloud Rat Shelves and Hideaway handmade cage shelf set' },
      detail: 'Cage set with hideaway, shelves and metal fittings. Check bar spacing.',
    },
    ratFeeder: {
      title: 'Rat Picnic Bench Food Bowl',
      href: '/products/wooden-rat-picnic-bench-feeding-bowl',
      image: { src: 'https://cdn.shopify.com/s/files/1/0834/5446/0252/files/4_9d80507e-053b-4e16-944e-b0de1a8a362f.png?v=1743373276', alt: 'Pet rat beside the orange picnic bench food bowl inside a cage' },
      detail: 'Cage feeder with metal fittings. Check standard wire bars and dimensions.',
    },
    ratSkull: {
      title: 'Gothic Skull Rat Hide and Hanging Nest',
      href: '/products/gothic-skull-rat-hideout-nest',
      image: { src: 'https://cdn.shopify.com/s/files/1/0834/5446/0252/files/1_604ff835-fb8f-43de-ad6e-716ee55d9473.png?v=1743373333', alt: 'Gothic Skull Rat Hideout and Hanging Nest handmade cage accessory' },
      detail: 'Indoor cage hide with chain and metal fittings. Check size and clearance.',
    },
    ratPixel: {
      title: 'Pixel Gamer Rat Cage Kit',
      href: '/products/pixel-gamer-rat-cage-kit',
      image: { src: 'https://cdn.shopify.com/s/files/1/0834/5446/0252/files/3_03007253-cd48-4ada-8f0b-3658908f97c9.png?v=1779111117', alt: 'Retro TV rat hide included in Pixel gamer rat cage kit' },
      detail: 'Ready-made cage bundle with enclosed hides and shelves. Check cage fit.',
    },
    ratFantasy: {
      title: 'Fantasy RPG Rat Cage Accessories Kit',
      href: '/products/fantasy-rpg-rat-cage-kit',
      image: { src: 'https://cdn.shopify.com/s/files/1/0834/5446/0252/files/5_98ba5c09-ac16-4ffe-9e98-f30c2e854552.png?v=1779112385', alt: 'Fantasy RPG rat cage kit main product photo' },
      detail: 'Ready-made cage bundle with hides and dragon shelf set. Check cage fit.',
    },
    ratCollection: {
      title: 'Browse Rat Care and Enrichment',
      href: '/collections/rat-care-hub',
      detail: 'Compare current cage accessories, fittings and care details.',
    },
    harvest: {
      title: 'Harvest Goddess Planter',
      href: '/products/harvest-goddess-planter',
      image: { src: 'https://cdn.shopify.com/s/files/1/0834/5446/0252/files/planted-spider-19.png?v=1775940356', alt: 'Harvest Goddess cast stone planter with spider plant' },
      detail: 'Cast stone with a hand-finished surface. Indoor or sheltered outdoor display.',
    },
    littleCritic: {
      title: 'The Little Critic Owl Garden Ornament',
      href: '/products/the-little-critic',
      image: { src: 'https://cdn.shopify.com/s/files/1/0834/5446/0252/files/hero-experiment-20260905-4521301265.png?v=1788625393', alt: 'The Little Critic Owl Garden Ornament product hero view' },
      detail: 'Cast stone, resin and acrylic paint. Indoor or outdoor display.',
    },
    alligator: {
      title: 'Cast Stone Crocodile Garden Ornament',
      href: '/products/cheeky-alligator-cast-stone-sculpture',
      image: { src: 'https://cdn.shopify.com/s/files/1/0834/5446/0252/files/2_7ca77a22-2fc1-4791-a855-7ea7278e64ca.png?v=1743373394', alt: 'Cast stone crocodile garden ornament held in one hand for scale' },
      detail: 'Hand-finished cast stone. Indoor or outdoor display.',
    },
    gardenCollection: {
      title: 'Browse Garden Ornaments',
      href: '/collections/garden-collection',
      detail: 'Compare current garden pieces by material, scale and placement.',
    },
    statementGraffiti: {
      title: 'Custom Graffiti Planter',
      href: '/products/statement-graffiti-planter',
      image: { src: 'https://cdn.shopify.com/s/files/1/0834/5446/0252/files/1_4_1.png?v=1743422184', alt: 'Planted custom graffiti stairwell planter with pink flamingo artwork' },
      detail: 'Custom wording, names, colours and themes. Indoor or sheltered use.',
    },
    urbanGraffiti: {
      title: 'Personalised Graffiti Plant Pot',
      href: '/products/urban-canvas-graffiti-planter',
      image: { src: 'https://cdn.shopify.com/s/files/1/0834/5446/0252/files/il_fullxfull.5160237630_6bvj.jpg?v=1743368705', alt: 'Planted personalised graffiti pot with purple lettering and green moss detail' },
      detail: 'Hand-cast stone and painted finish. Custom wording and colours for indoor or sheltered use.',
    },
    sculptedCollection: {
      title: 'Browse Sculpted Planters',
      href: '/collections/sculpted-planters',
      detail: 'Compare current cast-stone planter shapes, finishes and use details.',
    },
    discoPot: {
      title: 'Disco Ball Plant Pot',
      href: '/products/disco-ball-plant-pot',
      image: { src: 'https://cdn.shopify.com/s/files/1/0834/5446/0252/files/00-thumbnail-silver-pothos.png?v=1776863042', alt: 'Silver mirror mosaic cylinder plant pot with trailing green pothos' },
      detail: 'Real glass mirror tiles. Indoor display with drainage-hole or cache-pot choices.',
    },
    heartthrob: {
      title: 'Heartthrob Mirror Ball Heart Wall Art',
      href: '/products/heartthrob-mirror-ball-heart-wall-art',
      image: { src: 'https://cdn.shopify.com/s/files/1/0834/5446/0252/files/01-thumbnail-approved.png?v=1776930806', alt: 'Heartthrob mirror ball heart wall art approved thumbnail' },
      detail: 'Hand-finished silver mirror tiles on a sculpted form. Indoor wall art.',
    },
    hangingDisco: {
      title: 'Hanging Disco Ball Planter',
      href: '/products/hanging-disco-ball-planter',
      image: { src: 'https://cdn.shopify.com/s/files/1/0834/5446/0252/files/glitter-ball-1.png?v=1776016136', alt: 'The Glitter Ball hanging disco ball planter' },
      detail: 'Glass mirror tiles with a black chain. Indoor hanging or shelf display.',
    },
    discoCollection: {
      title: 'Browse Disco Decor',
      href: '/collections/disco',
      detail: 'Compare current reflective pieces, planters and wall decor.',
    }
  };

  function make(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function makeControl(tag, className, text) {
    var node = make(tag, className);
    node.appendChild(make('span', 'btn__text', text));
    return node;
  }

  function optionLabel(questionId, optionId) {
    var question = QUESTIONS.filter(function (item) { return item.id === questionId; })[0];
    var option = question && question.options.filter(function (item) { return item.id === optionId; })[0];
    return option ? option.title : '';
  }

  function itemList(items) {
    return items.map(function (key) { return ITEMS[key]; });
  }

  function itemAction(item) {
    return item.href.indexOf('/products/') === 0 ? 'View product details' : 'Browse collection';
  }

  function questionsFor(answers) {
    var needs = QUESTIONS[1].options.filter(function (option) {
      if (option.id === 'reflective') return answers.world === 'home';
      if (option.id === 'personal') return answers.world !== 'rat';
      return true;
    });
    var questions = [QUESTIONS[0], { id: 'need', label: QUESTIONS[1].label, options: needs }];
    if (answers.world === 'memorial' || answers.world === 'mixed' ||
        (answers.world === 'home' && answers.need === 'personal')) questions.push(QUESTIONS[2]);
    return questions;
  }

  function productMedia(item) {
    if (!item.image) return null;
    var media = make('div', 'media-wrapper rn-gift-catalogue__card-media');
    var image = make('img');
    image.src = item.image.src;
    image.alt = item.image.alt || item.title;
    image.loading = 'eager';
    image.decoding = 'async';
    media.appendChild(image);
    return media;
  }

  function memorialResult(need, details) {
    if (need === 'useful') {
      if (details === 'name' || details === 'both') {
        return {
          kicker: 'Memorials and keepsakes',
          title: 'A name-led memorial marker',
          copy: 'A short name points towards a cast-stone marker. Check the lettering, size and intended placement on each product page before choosing.',
          items: itemList(['acornMarker', 'pawMarker', 'memorialCollection'])
        };
      }
      return {
        kicker: 'Memorials and keepsakes',
        title: 'A ready-made remembrance piece',
        copy: 'Choose a standard keepsake or statue when you want a useful place to begin. Check the object, material and display guidance before deciding.',
        items: itemList(['sleepingCat', 'acornUrn', 'urnCollection'])
      };
    }
    if (need === 'sculptural') {
      if (details === 'photo' || details === 'both') {
        return {
          kicker: 'Memorials and keepsakes',
          title: 'A photo-led sculptural keepsake',
          copy: 'A clear photo opens the custom sculpture option. Each product page explains the photographs, wording and preview steps for that design.',
          items: itemList(['customBust', 'customPlanter', 'photoCollection'])
        };
      }
      if (details === 'name') {
        return {
          kicker: 'Memorials and keepsakes',
          title: 'A sculptural name-led keepsake',
          copy: 'A short name suits a cast-stone marker or initialled urn. Compare the shapes and check the exact personalisation field on the product page.',
          items: itemList(['acornMarker', 'acornUrn', 'memorialCollection'])
        };
      }
      return {
        kicker: 'Memorials and keepsakes',
        title: 'A standard sculptural keepsake',
        copy: 'Start with a ready-made memorial shape, then compare the material, scale and intended placement before choosing.',
        items: itemList(['sleepingCat', 'acornUrn', 'urnCollection'])
      };
    }
    if (details === 'photo') {
      return {
        kicker: 'Memorials and keepsakes',
        title: 'Start with a photo-led keepsake',
          copy: 'A clear photo gives you a direct option for a personal memorial piece. Each product page explains the photographs, wording and preview steps for that design.',
        items: itemList(['customBust', 'customWall', 'photoCollection'])
      };
    }
    if (details === 'both') {
      return {
        kicker: 'Memorials and keepsakes',
        title: 'You have the useful starting details',
          copy: 'A photo and a name are useful for the photo-led gifts below. Open the product page to check the exact upload, wording and preview requirements before ordering.',
        items: itemList(['customBust', 'customPlanter', 'photoCollection'])
      };
    }
    if (details === 'name') {
      return {
        kicker: 'Memorials and keepsakes',
        title: 'Start with a name-led memorial',
          copy: 'A short name or wording suits a marker option. Check the exact personalisation field and placement on the product page before you choose.',
        items: itemList(['acornMarker', 'pawMarker', 'memorialCollection'])
      };
    }
    return {
      kicker: 'Memorials and keepsakes',
      title: 'Browse a standard memorial first',
      copy: 'If you are still choosing the personal detail, start with a standard design and compare the object, finish and placement before deciding.',
      items: itemList(['sleepingCat', 'acornUrn', 'urnCollection'])
    };
  }

  function ratResult(need) {
    if (need === 'useful') {
      return {
        kicker: 'Rat Care and Enrichment',
        title: 'Choose something useful for the cage',
         copy: 'These ready-made cage accessories cover a practical setup need. Check dimensions, cage-bar spacing, fittings and care on each product page.',
        items: itemList(['ratStarter', 'ratCloud', 'ratCollection'])
      };
    }
    if (need === 'sculptural') {
      return {
        kicker: 'Rat Care and Enrichment',
        title: 'Choose a themed cage starting point',
         copy: 'The pieces below are ready-made cage accessories with a strong visual theme. Check the dimensions, fittings and cage layout before choosing one.',
        items: itemList(['ratPixel', 'ratFantasy', 'ratCollection'])
      };
    }
    return {
      kicker: 'Rat Care and Enrichment',
      title: 'Start with a cage piece they can use',
      copy: 'These ready-made accessories give you a practical place to begin. Check the product details for fit, fittings, care and placement.',
      items: itemList(['ratFeeder', 'ratSkull', 'ratCollection'])
    };
  }

  function homeResult(need, details) {
    if (need === 'reflective') {
      return {
        kicker: 'Sculptural Home and Garden',
        title: 'Start with a reflective room piece',
        copy: 'These pieces use hand-finished mirror tiles for indoor styling. Check each product page for wall, shelf, plant, size and care details before choosing.',
        items: itemList(['discoPot', 'heartthrob', 'discoCollection'])
      };
    }
    if (need === 'personal' && details === 'photo') {
      return {
        kicker: 'Sculptural Home and Garden',
        title: 'Turn a pet photo into a planter',
        copy: 'A clear pet photo can be the starting point for a cast-stone portrait planter. Check the photo requirements and size on the product page.',
        items: itemList(['customPlanter', 'sculptedCollection'])
      };
    }
    if (need === 'personal' && (details === 'name' || details === 'both')) {
      return {
        kicker: 'Sculptural Home and Garden',
        title: 'Choose a custom wording option',
        copy: 'The custom planter pages explain the wording, colour and theme brief for each design. A photo is not assumed to be part of the brief, so check what the listing asks for before ordering.',
        items: itemList(['statementGraffiti', 'urbanGraffiti', 'sculptedCollection'])
      };
    }
    if (need === 'useful') {
      return {
        kicker: 'Sculptural Home and Garden',
        title: 'Choose a home for a plant',
        copy: 'Start with a planter for everyday use. Compare the size, drainage options and indoor or sheltered placement guidance on each product page.',
        items: itemList(['harvest', 'discoPot', 'sculptedCollection'])
      };
    }
    return {
      kicker: 'Sculptural Home and Garden',
      title: 'Start with a sculptural piece',
      copy: 'These ready-made pieces have different materials and placement guidance. Use the short details here, then open the product page before choosing the form that suits the space.',
      items: itemList(['harvest', 'littleCritic', 'gardenCollection'])
    };
  }

  function mixedResult(need, details) {
    var memorialKey = details === 'photo' || details === 'both'
      ? 'customBust'
      : details === 'name' ? 'acornMarker' : 'sleepingCat';
    var ratKey = need === 'useful' ? 'ratStarter' : 'ratCloud';
    var homeKey = need === 'reflective'
      ? 'discoPot'
      : need === 'personal' && (details === 'name' || details === 'both')
        ? 'statementGraffiti'
        : 'harvest';
    return {
      kicker: 'A look across the three worlds',
      title: 'Three useful places to begin',
      copy: 'Compare one gift from each Ripleys Nest world and let the product details decide. Each card gives the material or fit clue that matters first.',
      items: itemList([memorialKey, ratKey, homeKey])
    };
  }

  function resultFor(answers) {
    if (answers.world === 'memorial') return memorialResult(answers.need, answers.details);
    if (answers.world === 'rat') return ratResult(answers.need);
    if (answers.world === 'home') return homeResult(answers.need, answers.details);
    return mixedResult(answers.need, answers.details);
  }

  function setHeader(root) {
    var heading = root.querySelector('[data-rn-gift-catalogue-heading]');
    var intro = root.querySelector('[data-rn-gift-catalogue-intro]');
    if (heading) heading.textContent = 'Find a gift that fits the moment';
    if (intro) intro.textContent = 'Choose who you are shopping for, then narrow the current range. No photo, name or email is requested here.';
  }

  function renderQuestion(root, index, answers, questions) {
    var panel = root.querySelector('[data-rn-gift-catalogue-panel]');
    var question = questions[index];
    var fieldset = make('fieldset', 'rn-gift-catalogue__question');
    var legend = make('legend', 'h2', question.label);
    fieldset.appendChild(legend);
    fieldset.appendChild(make('p', 'rn-gift-catalogue__progress', 'Question ' + (index + 1) + ' of ' + questions.length));

    var options = make('div', 'rn-gift-catalogue__options');
    options.setAttribute('role', 'group');
    options.setAttribute('aria-label', question.label);
    question.options.forEach(function (option) {
      var selected = answers[question.id] === option.id;
      var button = make('button', 'btn btn--secondary rn-gift-catalogue__option' + (selected ? ' btn--active' : ''));
      button.type = 'button';
      button.setAttribute('data-rn-gift-catalogue-option', option.id);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      var buttonText = make('span', 'btn__text');
      buttonText.appendChild(make('strong', 'rn-gift-catalogue__option-title', option.title));
      buttonText.appendChild(make('span', 'rn-gift-catalogue__option-desc', option.desc));
      button.appendChild(buttonText);
      options.appendChild(button);
    });
    fieldset.appendChild(options);

    var actions = make('div', 'rn-gift-catalogue__question-actions');
    if (index > 0) {
      var back = makeControl('button', 'btn btn--secondary rn-gift-catalogue__back', 'Back');
      back.type = 'button';
      back.setAttribute('data-rn-gift-catalogue-back', '');
      actions.appendChild(back);
    }
    var next = makeControl('button', 'btn btn--primary rn-gift-catalogue__next', index === questions.length - 1 ? 'Show gift suggestions' : 'Next');
    next.type = 'button';
    next.setAttribute('data-rn-gift-catalogue-next', '');
    actions.appendChild(next);
    actions.appendChild(make('p', 'rn-gift-catalogue__question-note', 'Choose one option to continue.'));
    fieldset.appendChild(actions);
    panel.replaceChildren(fieldset);
  }

  function renderResult(root, answers) {
    var panel = root.querySelector('[data-rn-gift-catalogue-panel]');
    var result = resultFor(answers);
    var wrap = make('div', 'rn-gift-catalogue__result');
    wrap.appendChild(make('p', 'text-subheading rn-gift-catalogue__result-kicker', result.kicker));
    var heading = make('h2', 'h2 focus-none rn-gift-catalogue__result-heading', result.title);
    heading.tabIndex = -1;
    wrap.appendChild(heading);
    wrap.appendChild(make('p', 'rte rn-gift-catalogue__result-copy', result.copy));

    var selection = make('p', 'rn-gift-catalogue__result-selection');
    selection.appendChild(make('strong', '', 'You chose: '));
    var chosen = [optionLabel('world', answers.world), optionLabel('need', answers.need)];
    if (answers.details) chosen.push(optionLabel('details', answers.details));
    selection.appendChild(document.createTextNode(chosen.filter(function (label) { return label; }).join(' / ')));
    wrap.appendChild(selection);

    var list = make('ul', 'rn-gift-catalogue__cards');
    result.items.forEach(function (item) {
      var li = make('li', 'rn-gift-catalogue__card');
      var media = productMedia(item);
      if (media) li.appendChild(media);
      var anchor = make('a', 'btn btn--secondary rn-gift-catalogue__card-link');
      anchor.href = item.href;
      var anchorText = make('span', 'btn__text');
      anchorText.appendChild(make('strong', 'rn-gift-catalogue__card-title', item.title));
      anchorText.appendChild(make('span', 'rn-gift-catalogue__card-detail', item.detail));
       anchorText.appendChild(make('span', 'rn-gift-catalogue__card-action', itemAction(item)));
      anchor.appendChild(anchorText);
      li.appendChild(anchor);
      list.appendChild(li);
    });
    wrap.appendChild(list);
    wrap.appendChild(make('p', 'rn-gift-catalogue__result-disclosure', 'Check each page for current price, variants, measurements, availability, fit, delivery and any personalisation details.'));

    var actions = make('div', 'rn-gift-catalogue__result-actions');
    var restart = makeControl('button', 'btn btn--secondary rn-gift-catalogue__restart', 'Start again');
    restart.type = 'button';
    restart.setAttribute('data-rn-gift-catalogue-restart', '');
    actions.appendChild(restart);
    actions.appendChild(make('p', 'rn-gift-catalogue__result-note', 'Your choices stay on this page.'));
    wrap.appendChild(actions);
    panel.replaceChildren(wrap);
    heading.focus();
  }

  function init(root) {
    if (!root || root.dataset.rnGiftCatalogueReady === 'true') return;
    root.dataset.rnGiftCatalogueReady = 'true';
    setHeader(root);
    var state = { index: 0, answers: {}, questions: QUESTIONS };
    renderQuestion(root, state.index, state.answers, state.questions);

    root.addEventListener('click', function (event) {
      var option = event.target.closest('[data-rn-gift-catalogue-option]');
      if (option) {
        var question = state.questions[state.index];
        var answer = option.getAttribute('data-rn-gift-catalogue-option');
        if (state.answers[question.id] !== answer) {
          if (question.id === 'world') delete state.answers.need;
          if (question.id === 'world' || question.id === 'need') delete state.answers.details;
        }
        state.answers[question.id] = answer;
        state.questions = questionsFor(state.answers);
        root.querySelectorAll('[data-rn-gift-catalogue-option]').forEach(function (node) {
          node.setAttribute('aria-pressed', node === option ? 'true' : 'false');
          node.classList.toggle('btn--active', node === option);
        });
        root.querySelector('.rn-gift-catalogue__progress').textContent = 'Question ' + (state.index + 1) + ' of ' + state.questions.length;
        root.querySelector('[data-rn-gift-catalogue-next] .btn__text').textContent = state.index === state.questions.length - 1 ? 'Show gift suggestions' : 'Next';
        root.querySelector('.rn-gift-catalogue__question-note').textContent = 'Choose one option to continue.';
        return;
      }

      var back = event.target.closest('[data-rn-gift-catalogue-back]');
      if (back) {
        state.index = Math.max(0, state.index - 1);
        renderQuestion(root, state.index, state.answers, state.questions);
        return;
      }

      var next = event.target.closest('[data-rn-gift-catalogue-next]');
      if (next) {
        var current = state.questions[state.index];
        if (!state.answers[current.id]) {
          var note = root.querySelector('.rn-gift-catalogue__question-note');
          if (note) note.textContent = 'Choose one option before continuing.';
          return;
        }
        if (state.index === state.questions.length - 1) {
          renderResult(root, state.answers);
        } else {
          state.index += 1;
          renderQuestion(root, state.index, state.answers, state.questions);
        }
        return;
      }

      var restart = event.target.closest('[data-rn-gift-catalogue-restart]');
      if (restart) {
        state.index = 0;
        state.answers = {};
        state.questions = QUESTIONS;
        renderQuestion(root, state.index, state.answers, state.questions);
      }
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-rn-gift-catalogue-picker]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); }, { once: true });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
}());
